var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-145 -414) translate(120 76) translate(16 300) translate(9 38)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.12,
    fillRule: "nonzero",
    transform: "translate(0 28.16)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.429,
    height: 7.68,
    rx: 3.84
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.12,
    fillRule: "nonzero",
    transform: "translate(36.571 28.16)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.429,
    height: 7.68,
    rx: 3.84
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.12,
    fillRule: "nonzero",
    transform: "translate(0 38.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.429,
    height: 7.68,
    rx: 3.84
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.12,
    fillRule: "nonzero",
    transform: "translate(36.571 38.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.429,
    height: 7.68,
    rx: 3.84
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.12,
    fillRule: "nonzero",
    transform: "translate(0 7.68)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.429,
    height: 7.68,
    rx: 3.84
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.12,
    fillRule: "nonzero",
    transform: "translate(36.571 7.68)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.429,
    height: 7.68,
    rx: 3.84
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.12,
    fillRule: "nonzero",
    transform: "translate(0 17.92)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.429,
    height: 7.68,
    rx: 3.84
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.12,
    fillRule: "nonzero",
    transform: "translate(36.571 17.92)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.429,
    height: 7.68,
    rx: 3.84
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.12,
    fillRule: "nonzero",
    transform: "translate(0 48.64)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.429,
    height: 7.68,
    rx: 3.84
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.12,
    fillRule: "nonzero",
    transform: "translate(36.571 48.64)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.429,
    height: 7.68,
    rx: 3.84
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoColumns);
export default __webpack_public_path__ + "static/media/twoColumns.2ab488cb1484b6a552550ff9ea08cb5d.svg";
export { ForwardRef as ReactComponent };